import comp from "./AddEditLinkModal";
export default comp;
